import { SVGProps } from 'react';

import { WithRef } from 'support/types/withRef';

export const InProgresCircle = ({ ref, ...props }: WithRef<SVGProps<SVGSVGElement>, SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} ref={ref}>
      <path
        d="M12 21a9 9 0 1 0 0-18m-3 9.75L11.25 15 15 9.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 21a9 9 0 1 1 0-18m-3 9.75L11.25 15 15 9.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="4 3"
      />
    </svg>
  );
};
